import React, { useState } from "react"
import {
	Grid,
	Typography
} from "@material-ui/core"
import {
	ActionDialog,
	Notification
} from "@/components"
import ApiService from "@/services/Api"
import { QueueName } from "@/pages/Admin/Dashboard/Metrics/ProductMessageMetrics/QueueMetrics/DetailedQueueMetrics"
import { useGlobalStateStore } from "@/store/GlobalState"

type DetailedQueueProps = {
	disabled: boolean
	queueNameLabel: string
	queueName: QueueName
	children: React.ReactNode
}

export type ProductMessageQueueName =
"IntegrationMessage" |
"MessageBlastMessage" |
"ChatBotMessage" |
"ActiveCampaignPluginAutomationMessage" |
"SnoozeMessage"

const ClearQueue: React.FC<DetailedQueueProps> = (props) => {
	const {
		disabled,
		queueNameLabel,
		queueName,
		children
	} = props

	const [openDialog, setOpenDialog] = useState(false)
	const [loading, setLoading] = useState(false)
	const globalStateStore = useGlobalStateStore()
	const inboxChannelIntegrationId = globalStateStore.currentChannel?.integrationId

	const handleOpenDialog = async () => {
		setOpenDialog(true)
	}

	const handleCloseDialog = () => {
		setOpenDialog(false)
	}

	const handleSave = async () => {
		setLoading(true)
		try {
			const queueNameToMessageQueue: Record<QueueName, ProductMessageQueueName> = {
				activeCampaignPluginAutomationMessages: "ActiveCampaignPluginAutomationMessage",
				chatBotMessages: "ChatBotMessage",
				integrationMessages: "IntegrationMessage",
				messageBlastMessages: "MessageBlastMessage",
				snoozeMessages: "SnoozeMessage"
			}

			const messageQueueName = queueNameToMessageQueue[queueName]

			if (messageQueueName) {
				await ApiService.get(`/inbox/admin/channels/${inboxChannelIntegrationId}/queues/${queueName}/clear`)
			}
		} catch (error) {
			Notification.error({
				message: "Ocorreu um erro inesperado ao limpar a fila."
			})
		}
		setLoading(false)
		handleCloseDialog()
	}

	return (
		<>
			<Grid
				onClick={disabled ? undefined : handleOpenDialog}
				{...(disabled && {
					style: {
						pointerEvents: "auto"
					}
				})}
			>
				{children}
			</Grid>
			<ActionDialog
				title={`Limpar fila de ${queueNameLabel}`}
				openDialog={openDialog}
				saveText="Limpar"
				onClose={handleCloseDialog}
				onSave={handleSave}
				loading={loading}
				hideCloseButton
				maxWidth="sm"
				fullWidth>
				<Grid item>
					<Typography>
						Tem certeza que seja limpar a fila essa ação é <strong>irreversível</strong>
					</Typography>
				</Grid>
			</ActionDialog>
		</>
	)
}

export default ClearQueue
